<template>
  <div class="container">
    <!-- Filtlro -->
    <v-form ref="form">
      <p>Buscar Por:</p>
      <v-row class="justify-start mt-3 ml-3">
        <v-col :cols="8" >
          <v-autocomplete
                v-model="form.filters.secretariaId"
                label="Secretaria Executiva"
                dense
                outlined
                item-text="nome"
                item-value="codigo"
                return-object
                :items="form.listaSecretarias"
            />
        </v-col>
      </v-row>
      <v-row class="btn-group">
        <v-col class="text-end">
          <v-btn
              color="primary"
              @click="resetForm"
              outlined
          >
            Limpar
          </v-btn>
          <v-btn
              color="primary"
              @click="buscarDashboard"
          >
            Buscar
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
    <!-- Dashboard SEE -->
    <div v-if="dashboardSEE != null" class="mt-7">
        <StatusFormacao
          @visualizar-listagem="openDialogListarComFormacao(null)"
          :status-list = "dashboardSEE?.statusFormacao"
          :data-hora-info="dashboardSEE?.dataHoraInfo"
      />
      <div>
      <!-- Cards -->
       <v-row>
        <v-col cols="12" md="4">
          <v-card class="pa-4 text-center">
            <div class="subtitle-2 mb-2 font-weight-medium">Total De Formações</div>
            <div class="display-1 font-weight-bold blue--text mb-2">{{ dashboardSEE?.info?.totalFormacoes ?? 0 }}</div>
            <v-btn outlined small color="blue" @click="openDialogListarFormacoes()">Visualizar Listagem</v-btn>
          </v-card>
        </v-col>

        <v-col cols="12" md="4">
          <v-card class="pa-4 text-center">
            <div class="subtitle-2 mb-2 font-weight-medium">Participantes</div>
            <div class="display-1 font-weight-bold orange--text mb-2">{{ dashboardSEE?.info?.totalParticipantes ?? 0 }}</div>
            <v-btn outlined small color="orange" @click="openDialogListarParticipantes()" >Visualizar Listagem</v-btn>
          </v-card>
        </v-col>

        <v-col cols="12" md="4">
          <v-card class="pa-4 text-center">
            <div class="subtitle-2 mb-2 font-weight-medium">Média De Frequência</div>
            <div class="display-1 font-weight-bold green--text mb-9">{{ dashboardSEE?.info?.mediaFrequencia ?? 0 }}%</div>
          </v-card>
        </v-col>
      </v-row>
      <!-- Gráficos -->
      <v-row style="height: 500px" class="fill-height">
        <v-col cols="12" md="6" class="fill-height">
          <v-card class="pa-4 text-center fill-height" style="height: 95%">
            <div class="mb-4">Formações</div>
            <PieChart :chartData="dataPizza" />
          </v-card>
        </v-col>

        <v-col cols="12" md="6">
          <v-row class="fill-height">
            <v-col cols="12" md="12">
              <v-card class="fill-height d-flex flex-column justify-center align-center" >
                <div>Presenças</div>
                <div class="d-flex justify-center align-center mt-2">
                  <div class="display-1 font-weight-bold mr-3">{{ dashboardSEE?.info?.totalPresencas ?? 0}}</div>
                  <v-icon large color="green">mdi-check-circle-outline</v-icon>
                </div>
              </v-card>
            </v-col>

            <v-col cols="12" md="12">
              <v-card class="fill-height d-flex flex-column justify-center align-center">
                <div>Ausências</div>
                <div class="d-flex justify-center align-center mt-2">
                  <div class="display-1 font-weight-bold mr-3">{{ dashboardSEE?.info?.totalAusencias ?? 0}}</div>
                  <v-icon large color="red">mdi-clock-time-four-outline</v-icon>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="6" md="6" class="fill-height">
          <v-card class="pa-4 text-center fill-height" style="height: 100%">
            <template v-if="funcoesChartData.length > 0">
              <HorizontalBarChartSimple
                :rawData="funcoesChartData"
                :height="stackedChartHeightFunctions"
                :formatAsPercent="false"
                title="Maiores Quantidades de Funções em Formação"
              />
            </template>
            <template v-else>
              <p style="color: #333;">Não há dados!</p>
            </template>
          </v-card>
        </v-col>
        <v-col cols="6" md="6" class="fill-height">
          <v-card class="pa-4 text-center fill-height" style="height: 100%">
            <template v-if="frequenciaChartData.length > 0">
              <HorizontalBarChartSimple
                :rawData="frequenciaChartData"
                :height="stackedChartHeight"
                :formatAsPercent="true"
                title="Frequência por Formação"
              />
            </template>
            <template v-else>
              <p style="color: #333;">Não há dados!</p>
            </template>
          </v-card>
        </v-col>
      </v-row>
      <v-row class="btn-group">
        <v-col class="text-end">
          <v-btn
              color="primary"
              @click="exportarDadosPdf"
              outlined
          >
            Exportar Gráficos
          </v-btn>
        </v-col>
      </v-row>
     </div>
    </div>
    <!-- Dialogs -->
    <ListarFormacaoPorStatusDialog
        v-if="dialogListarFormacaoPorStatusDialog.visible"
        :visible="dialogListarFormacaoPorStatusDialog.visible"
        :content="dialogListarFormacaoPorStatusDialog.content"
        @onClose="dialogListarFormacaoPorStatusDialog.close()"
    ></ListarFormacaoPorStatusDialog>
    <ListarFormacoesDialog
        v-if="dialogListarFormacoes.visible"
        :visible="dialogListarFormacoes.visible"
        :content="dialogListarFormacoes.content"
        @onClose="dialogListarFormacoes.close()"
    ></ListarFormacoesDialog>
    <ListarParticipantesDialog
        v-if="dialogListarParticipantes.visible"
        :visible="dialogListarParticipantes.visible"
        :content="dialogListarParticipantes.content"
        @onClose="dialogListarParticipantes.close()"
    ></ListarParticipantesDialog>
  </div>
</template>

<script>
import {Dialog} from "commons/classes/dialog";
import DashboardFormacaoService from "services/dashboard-formacao.service";
import ListarFormacaoPorStatusDialog from "views/post-login/administrador/manter-dashboard-formacao/dialogs/SEE/ListarFormacaoPorStatusDialog.vue";
import ListarFormacoesDialog from "views/post-login/administrador/manter-dashboard-formacao/dialogs/SEE/ListarFormacoesDialog.vue";
import ListarParticipantesDialog from "views/post-login/administrador/manter-dashboard-formacao/dialogs/SEE/ListarParticipantesDialog.vue";
import {Dashboard} from "commons/classes/dashboard";

export default {
  name: "ManterDashboardFormacaoSEEView",
  mixins: [DashboardFormacaoService],
  components: {
    StatusFormacao: () => import('views/post-login/administrador/manter-dashboard-formacao/components/StatusFormacao.vue'),    
    PieChart: () => import('@/components/Graficos/PieChart.vue'),
    HorizontalBarChartSimple: () => import('@/components/Graficos/HorizontalBarChartSimple.vue'),
    //Dialogs
    ListarFormacaoPorStatusDialog,
    ListarFormacoesDialog,
    ListarParticipantesDialog
  },
  data: () => ({
    dialogListarFormacaoPorStatusDialog: Dialog.Build(),
    dialogListarFormacoes: Dialog.Build(),
    dialogListarParticipantes: Dialog.Build(),
    dashboardSEE: null,
    dataPizza: {
      labels: ['SEDE', 'SEGE'],
      datasets: [
        {
          data: [1, 1],
          backgroundColor: ['#4CAF50','#3F51B5', ]
        }
      ]
    },
    frequenciaChartData: [],
    funcoesChartData: [],
    form:{
      filters: {
        secretariaId: null,
      },
      listaSecretarias: [],
    },
  }),
  methods: {
    buscarDashboard(){
      this.dashboardSEE = null;
      this.buscarDashboardSee();
    },
    buscarDashboardSee() {
      this.$buscarDashboardSee({ params: {
        seeCodigo: this.form.filters.secretariaId?.codigo,
      } }).then(
          ({ data }) => {
            this.dashboardSEE = data.dashboard
            this.dataPizza.datasets[0].data = data?.dashboard?.grafico?.dataPizza;
            this.frequenciaChartData = data?.dashboard?.grafico?.frequenciaData || [];
            this.funcoesChartData = data?.dashboard?.grafico?.funcoesData || [];
          }
      )
    },
    openDialogListarComFormacao() {
      this.dialogListarFormacaoPorStatusDialog.open(new Dashboard({id: this.dashboardSEE?.seeCodigo, origemId: 2}));
    },
    openDialogListarFormacoes() {
      this.dialogListarFormacoes.open(new Dashboard({id: this.dashboardSEE?.seeCodigo, origemId: 2}));
    },
    openDialogListarParticipantes() {
      this.dialogListarParticipantes.open(new Dashboard({id: this.dashboardSEE?.seeCodigo, origemId: 2}));
    },
    resetForm() {
      this.$resetForm();
      this.dashboardSEE = null;
    },
    async exportarDadosPdf() {
      this.showPageLoading();
      try {
        const { data } = await this.$buscarDashboardSeePdf(this.$montarParamsFilters(
            {seeCodigo: this.form.filters.secretariaId?.codigo}));
        const url = URL.createObjectURL(data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "SIGFOCO.FormacoesSEE.pdf");
        document.body.appendChild(link);
        link.click();
        this.$notifySuccess("Operação realizada com sucesso.");
      } finally {
        this.hidePageLoading();
      }
    },
  },
  computed: {
    stackedChartHeight() {
      return this.frequenciaChartData?.length > 5 ? 650 : 400;
    },
    stackedChartHeightFunctions() {
      return this.funcoesChartData?.length > 5 ? 650 : 400;
    }
  },
  mounted() {
    this.$obterListaSecretarias().then(({ data }) => {
        this.form.listaSecretarias = data.lista;
    });
  },
}
</script>